import { Matches } from '@/entities';
import { extractTieBreakerInfo } from '@/infrastructure/utils/tieBreakerHelpers';
import { useMemo } from 'react';

export const useTieBreakerMatch = (matchupData?: Matches) => {
	return useMemo(() => extractTieBreakerInfo(matchupData), [matchupData]);
};
